import React from "react";
import { motion } from "framer-motion";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero">
      <motion.div
        initial={{ x: -30, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="hero-left"
      >
        <span className="badge">New · 2025</span>

        <h1 className="hero-title">
          Advocate management that keeps your practice in order
        </h1>

        <p className="hero-subtitle">
          Manage clients, cases, hearings and invoices from a single dashboard.
          Built for small law firms and independent advocates who want to save
          time and reduce admin.
        </p>

        <div className="cta-row">
          <a href="#contact" className="btn btn-primary">
            Request Demo
          </a>
          <a href="#features" className="btn btn-outline">
            Explore Features
          </a>
        </div>

        <div className="stats">
          <div className="stat">
            <div className="stat-number">120+</div>
            <div className="stat-label">Firms onboarded</div>
          </div>

          <div className="stat">
            <div className="stat-number">4.8</div>
            <div className="stat-label">Avg. rating</div>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ scale: 0.98, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="hero-right"
      >
        <div className="mockup">
          <img
            src="https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=1200&q=60"
            alt="dashboard mockup"
          />
        </div>
      </motion.div>
    </section>
  );
}
